import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  styled,
  Typography,
  useTheme,
} from "@mui/material";
import UserTitle from "./UserTitle";
import { useState } from "react";

import moment from "moment";
import { MoreVert } from "@mui/icons-material";
import DeleteComment from "./CommentActions/DeleteComment";
import _cookies from "../../../shared/utils/_cookies";

const CommentListItem = styled("ul")(({ theme }) => ({
  display: "inline-block",
  width: "100%",
  whiteSpace: "break-spaces",
  wordWrap: "break-word",
  listStyleType: "none",
  ".reply_button": {
    fontWeight: "600",
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

const CommentWrapper = styled("li")(({ theme }) => ({
  listStyleType: "none",
}));

export const Comment = ({ comment, canBeReplied, onClickReplyComment }) => {
  const [optionsAnchor, setOptionsAnchor] = useState(null);
  const optionsOpen = Boolean(optionsAnchor);
  const date = moment(comment.commentDate).fromNow();
  const theme = useTheme();

  const handleClickReplyComment = () => {
    onClickReplyComment(comment.id);
  };

  const openOptions = (event) => {
    setOptionsAnchor(event.currentTarget);
  };
  const closeOptions = () => {
    setOptionsAnchor(null);
  };
  const showDeleteCommentOption = () => {
    return Boolean(_cookies.getItem("auth").user?.profile?.isGestor?.ID);
  };
  const showOptions = () => {
    return showDeleteCommentOption();
  };

  return (
    <CommentWrapper>
      <CommentListItem>
        <Box className="relative pr-[20px]">
          <UserTitle
            userData={{
              pictureURL: `${comment.photo}`,
              name: comment.name,
              studentId: comment.studentId,
            }}
            sx={{ width: "fit-content" }}
            secon
            dary={date}
          />
          {showOptions() && (
            <>
              <IconButton
                sx={{
                  position: "absolute",
                  right: "0",
                  padding: "0",
                  top: "10px",
                }}
                onClick={openOptions}
              >
                <MoreVert />
              </IconButton>
              <Menu
                anchorEl={optionsAnchor}
                open={optionsOpen}
                onClose={closeOptions}
              >
                {showDeleteCommentOption() && (
                  <DeleteComment postId={comment.postId} commentId={comment.id}>
                    {({ openDialog }) => {
                      return (
                        <MenuItem onClick={openDialog}>
                          Deletar comentário
                        </MenuItem>
                      );
                    }}
                  </DeleteComment>
                )}
              </Menu>
            </>
          )}
        </Box>
        <Typography sx={{ marginTop: 1 }}>{comment.comments}</Typography>
        <Box
          sx={{
            display: "flex",
            gap: 1,
            fontSize: theme.typography.subtitle2,
            marginTop: theme.spacing(1),
          }}
        >
          {canBeReplied && (
            <span className="reply_button" onClick={handleClickReplyComment}>
              Responder
            </span>
          )}
        </Box>
      </CommentListItem>
    </CommentWrapper>
  );
};

export const ParentComment = ({
  comment,
  onClickReplyComment,
  resetReplyingTo = () => {},
}) => {
  const [commentsExpanded, setExpanded] = useState(false);
  const theme = useTheme();
  const handleToggleComments = () => {
    setExpanded((prev) => {
      if (prev) {
        resetReplyingTo();
      }
      return !prev;
    });
    return;
  };
  return (
    <>
      <Comment
        comment={comment}
        canBeReplied
        onClickReplyComment={onClickReplyComment}
      />
      {!!comment.replies.length && (
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
          onClick={handleToggleComments}
        >
          <Box
            sx={{
              width: "24px",
              borderBottom: `1px solid black`,
            }}
          ></Box>
          <Typography variant="subtitle2">
            {!commentsExpanded
              ? `Ver respostas (${comment.replies.length})`
              : "Esconder respostas"}
          </Typography>
        </Box>
      )}
      {commentsExpanded && (
        <Box sx={{ ml: theme.spacing(4), "& > li": { marginTop: 1 } }}>
          {comment.replies.map((reply) => {
            return <Comment comment={reply} />;
          })}
        </Box>
      )}
    </>
  );
};
